<template>
	<div id="app">
		<transition name="router-fade" mode="out-in">
			<router-view v-if="isRouterAlive"></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isRouterAlive: true,
		};
	},
	methods: {
		// setFont(){

		// }
	}
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html, body {
  height: 100%;
}
/* router-fade */
.router-fade-enter-active,
.router-fade-leave-active {
	transition: opacity 0;
}

.router-fade-enter,
.router-fade-leave-active {
	opacity: 0;
}

body {
	overflow: hidden;
}

body,
html {
	width: 100%;
	height: 100%;
}
ul,
ol,
li {
	list-style: none;
	padding: 0;
	margin: 0;
}

#app {
	height: 1080px;
	width: 100%;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

</style>
